import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MemoryService } from '@services/memory/memory.service';
import { Models } from '@ibexfusion/models';
import { DataTableComponent, DataTableEvent } from '../data-table/data-table.component';
import * as _ from 'lodash';

@Component({
    selector: 'submenu-creator',
    templateUrl: './submenu-creator.component.html',
    styleUrls: ['./submenu-creator.component.scss'],
    standalone: false
})
export class SubmenuCreatorComponent implements OnInit {
  @ViewChild('assignedItemsTable') assignedItemsTable: DataTableComponent;
  title: string;
  menuItems: string[] = [];
  availableItemsProvider: MemoryService<Models.ImportAssignableMenuItem>;
  assignedItemsProvider: MemoryService<Models.ImportAssignableMenuItem>;
  public columns = [{ prop: 'importTitle' }, { prop: 'title' }];

  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,) {
    this.availableItemsProvider = this.data.menuitemProvider;
    if (this.data.assignedItems) {
      this.assignedItemsProvider = new MemoryService<Models.ImportAssignableMenuItem>(this.data.assignedItems);
    } else {
      this.assignedItemsProvider = new MemoryService<Models.ImportAssignableMenuItem>([]);
    }
  }

  ngOnInit() {
  }

  public assignItem(event: DataTableEvent): void {
    const importAssignableMenuItem = this.assignedItemsProvider.db.find(item => {
      return item.menuItemId === event.row.menuItemId;
    });

    if (importAssignableMenuItem) {
      return;
    }

    const itemToAssign = this.availableItemsProvider.db.find(item => {
      return item.menuItemId === event.row.menuItemId;
    });
    this.assignedItemsProvider.create(itemToAssign).then(() => this.assignedItemsTable.refresh());
  }

  public removeAssignedItem(event: DataTableEvent): void {
    this.assignedItemsProvider.remove(event.index).then(() => this.assignedItemsTable.refresh());
  }

  public save() {
    this.assignedItemsProvider.find(0, 100, {}).then(items => {
      this.dialogRef.close({
        menuItemIds: _.map(items.data, 'menuItemId'),
        title: this.title
      });
    });
  }
}
